
const SPEC_BY_NAME = {};
console.log("PARSER FIRST LOAD");

function configure (CONFIG) {
    // подготовим быстрый доступ: имя лога -> спецификация

    for (const def of CONFIG.logs) {
        for (const [logName, spec] of Object.entries(def)) {
            if (!Array.isArray(spec)) {
                console.warn(`⚠️ Лог ${logName} не в новом формате (массив). Пропускаю.`);
                continue;
            }
            SPEC_BY_NAME[logName] = spec;
        }
    }
}

function valid_log(log){
    const spec = SPEC_BY_NAME[log];
    return !!spec;
}


// helpers
const isSepToken = (t) => typeof t === 'string' && t.startsWith('|');
const stripDigits = (name) => name.replace(/#\d+$/, '');
const isAlpha = (ch) => !!ch && /[A-Za-z]/.test(ch);
const isDigitSignStar = (ch) => !!ch && /[0-9.\-*+]/.test(ch);

function parseBySpec(line, logName) {
    const varsSpec = SPEC_BY_NAME[logName];
    // ts и '='?
    const mTs = line.match(/^(\d+)(=)?/);
    if (!mTs) throw new Error('bad ts');
    const ts = Number(mTs[1]);
    const isRepeat = !!mTs[2];
    if (isRepeat) return { ts, repeat: true, values: null };

    let i = mTs[0].length;

    const peek = () => line[i];
    const consume = (n = 1) => { i += n; };
    const expectLiteral = (lit) => {
        if (line.slice(i, i + lit.length) !== lit) throw new Error(`expect "${lit}"`);
        i += lit.length;
    };

    const values = {};

    for (let k = 0; k < varsSpec.length; k++) {
        const token = varsSpec[k];

        if (isSepToken(token)) {
            const marker = token.slice(1);
            if (peek() === '|') consume(1); // допускаем случайный '|'
            expectLiteral(marker);
            continue;
        }

        const prev = (k > 0) ? varsSpec[k - 1] : null;
        const isFirst = k === 0;
        const needsPipe = !isFirst && !(prev && isSepToken(prev));
        if (needsPipe) {
            if (peek() !== '|') throw new Error('expected "|"');
            consume(1);
        }

        const start = i;
        while (i < line.length) {
            const ch = line[i];
            if (isAlpha(ch) || ch === '|') break;
            if (!isDigitSignStar(ch)) break;
            i++;
        }
        const rawVal = line.slice(start, i);
        const baseName = stripDigits(token);

        let value;
        if (baseName.endsWith('lost')) {
            if (rawVal === '+') value = 0;
            else if (rawVal === '-') value = 1;
            else if (rawVal === '*') value = '*';
            else value = (Number(rawVal) === 0) ? 0 : 1;
        } else {
            value = (rawVal === '*') ? '*' : Number(rawVal);
        }

        values[baseName] = value;
    }

    return { ts, repeat: false, values };
}

module.exports = {
    parseBySpec,
  configure,
  valid_log,
};